import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus18 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15 15",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0)",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(0 0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M13.1,5.6c1,3.1-0.6,6.5-3.7,7.5s-6.5-0.6-7.5-3.7s0.6-6.5,3.7-7.5c1.2-0.4,2.6-0.4,3.8,0 V0.8C5.7-0.3,1.8,1.9,0.8,5.6s1.1,7.6,4.8,8.7s7.6-1.1,8.7-4.8c0.4-1.3,0.4-2.6,0-3.8L13.1,5.6z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.6,3.4h-1.5v-1h1.5V1h1v1.5H14v1h-1.5v1.5h-1L11.6,3.4z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.8,5.6H3.7v-1H6v5.8H4.8V5.6z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.1,10.3c-0.3-0.1-0.5-0.4-0.7-0.6C7.2,9.4,7.1,9,7.1,8.7c0-0.6,0.3-1.1,0.8-1.4 C7.7,7.2,7.6,7,7.5,6.8C7.3,6.6,7.3,6.4,7.3,6.1c0-0.3,0.1-0.6,0.2-0.8C7.7,5,7.9,4.8,8.2,4.7c0.3-0.1,0.6-0.2,1-0.2 c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.5,0.3,0.7,0.6c0.2,0.2,0.3,0.5,0.2,0.8c0,0.2-0.1,0.5-0.2,0.7c-0.1,0.2-0.3,0.4-0.4,0.5 c0.3,0.1,0.5,0.3,0.6,0.6c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3-0.1,0.6-0.3,0.9c-0.2,0.3-0.4,0.5-0.7,0.6C9.6,10.6,8.8,10.6,8.1,10.3  M9.8,9.3c0.2-0.1,0.3-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6C9.7,8,9.4,7.9,9.2,7.9C9,7.9,8.7,8,8.5,8.1C8.4,8.3,8.3,8.5,8.3,8.7 c0,0.2,0.1,0.4,0.2,0.6C8.7,9.4,9,9.5,9.2,9.5C9.4,9.5,9.7,9.4,9.8,9.3 M9.7,6.7c0.3-0.3,0.3-0.7,0-1c-0.3-0.3-0.7-0.3-1,0 c-0.3,0.3-0.3,0.7,0,1C9,7,9.4,7,9.7,6.7",
					fill: "currentColor"
				})
			]
		}) })
	})
});
export { SvgPlus18 as ReactComponent };
